import { Box, Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Page footer: the service owner and year on the left, the two outside resources an
// operator reaches for on the right.
function Footer() {
  const { t }: { t: any } = useTranslation();
  return (
    <Box
      component="footer"
      className="footer-wrapper"
      sx={{
        mt: 4,
        px: { xs: 2, sm: 4 },
        py: 3,
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
        color: 'text.secondary'
      }}
    >
      <Typography variant="body2" color="text.secondary">
        &copy; {new Date().getFullYear()} Coinhouse Solutions
      </Typography>
      <Stack direction="row" spacing={3}>
        <Link href="https://coinhouse-solutions.readme.io/" target="_blank" rel="noopener noreferrer" variant="body2">
          {t('API documentation')}
        </Link>
        <Link href="https://www.coinhouse.com" target="_blank" rel="noopener noreferrer" variant="body2">
          coinhouse.com
        </Link>
      </Stack>
    </Box>
  );
}

export default Footer;
